module.exports = __webpack_public_path__ + "img/HEADER.8a2beb49.png";